import { Alert } from '@/shared/components/rebranded/Alert/Alert';
import { FieldProps, StringSchema } from '../../../../../form-generator/types';
import { URLs } from '../../../../../shared/URLs';
import { AlertButton, Wrapper } from './styles';

type HelpTextFieldProps = FieldProps<StringSchema, string>;

export const HelpTextFieldPestInsect = ({ schema }: HelpTextFieldProps) => {
  const navigate = () =>
    window.location.replace(URLs.MELD_SKADE_PRIVAT_HUS_HYTTE_INNBO);

  return (
    <Alert
      title={schema.title || 'OBS'}
      fluid
      variant={(schema.$uiOptions && schema.$uiOptions.alertType) || 'info'}
    >
      <Wrapper html={schema.description || schema.const || ''} />
      <AlertButton iconRight="arrow-right" variant="text" onClick={navigate}>
        Bruk en annen forsikring
      </AlertButton>
    </Alert>
  );
};
